import React from 'react'
import { Col, Row } from 'react-bootstrap'
import LrearnImg from "../assets/abt_vec_3.png"

interface Props {

}

const Education = (props: Props) => {
    return (
        <div className='p-5 mt-3 ' >
            <Row className='justify-content-center'>
            <Col md={5}>
                    <img src={LrearnImg} style={{ width: "100%" }} alt="" />
                </Col>
                <Col md={5} className='mt-5'>
                    <h1 className="learn_text1">ELEVATE YOUR EDUCATIONAL JOURNEY LAGEXCELGLOBAL</h1>
                    <p className="learn_info1">Elevate your educational journey with LagExcelGlobal! 🎓✨ Discover the key to hassle-free admission processing – our expert guidance comes at no cost to you! 🌐🆓 Unlock a world of opportunities. Kickstart your educational adventure today! #AdmissionSuccess #LagExcelGlobal #EducationForAll </p>
                        
                    <div className="mt-2"><a href="https://forms.gle/kETFxMSb8LE3taA59" target="_blank" rel="noopener noreferrer" className="btn btn-hero1 me-5">Start Now</a></div>
                </Col>
                
            </Row>
        </div>
    )
}

export default Education
